// extracted by mini-css-extract-plugin
export default {"container":"jQ-z","modal":"kQ-z","dimensions":"lQ-z","brandName":"mQ-z","productName":"nQ-z","labelValue":"oQ-z","recipientEmail":"pQ-z","recommendedFit":"qQ-z","hiddenField":"rQ-z"};